<template>
  <div id="Inicio" class="inicio">
    <MenuMovilTP />
    <MenuMovilUni />
  </div>
</template>

<script>
import ApiTecnicoProf from "@/services/ApiTecnicoProf";
import ApiBuscador from "@/services/ApiBuscador";
import Busqueda from "@/utils/Busqueda.js";
import TagsBusqueda from "@/components/buscadorTP/TagsBusqueda";
import Iconografia from "@/components/generales/Iconografia";
import MenuMovilTP from "@/components/generales/menuMovil/TecnicoProfesional";
import MenuMovilUni from "@/components/generales/menuMovil/AdmisionUniversitaria";
import { mapGetters, mapActions } from "vuex";
export default {
  components: {
    TagsBusqueda,
    Iconografia,
    MenuMovilTP,
    MenuMovilUni
  },
  data() {
    return {
      tipoVista: "detalle",
      listadoCarreras: [],
      mostrarFiltrosPantalla: false
    };
  },
  computed: {
    ...mapGetters([
      "getAreaConocimientoSeleccionada",
      "getCarreraGenericaSeleccionada",
      "getInstitucionSeleccionada",
      "getCarreras",
      "getBusquedasAplicadas",
      "getRegionSeleccionada",
      "getNombreCarreraSeleccionada"
    ]),
    vista() {
      return this.$store.state.vista;
    },
    cantidadCarreras() {
      return this.listadoCarreras.length;
    }
  },
  mounted() {
    this.tipoVista = this.vista;
  },
  methods: {
    ...mapActions([
      "setVista",
      "setCarreras",
      "setAreasCarrerasInstituciones",
      "setBusqueda",
      "setRegionSeleccionada",
      "setNombreCarreraSeleccionada",
      "setAreaConocimientoSeleccionada",
      "setCarreraGenericaSeleccionada",
      "setInstitucionSeleccionada",
      "setCriterioOrden"
    ]),
    cambiarVista(valor) {
      this.tipoVista = valor;
      this.setVista(valor);
    },
    async buscarCarreras(busqueda) {
      this.$emit("cargar");
      if (busqueda.region !== null || busqueda.carrera !== "") {
        if (busqueda.region !== null) {
          this.guardarBusquedaTags(busqueda.region, "REGION");
          this.setRegionSeleccionada(busqueda.region);
        }
        if (busqueda.carrera !== "") {
          this.guardarBusquedaTags(busqueda.carrera, "CARRERA");
          this.setNombreCarreraSeleccionada(busqueda.carrera);
        }
        this.buscarFiltrosAvanzadosPorRegion(busqueda.region);
        let carreras = await ApiTecnicoProf.getCarreras(
          busqueda.region,
          busqueda.carrera
        );
        if (carreras || carreras !== "") {
          if (!this.mostrarFiltrosPantalla) {
            this.mostrarFiltrosPantalla = true;
          }
          this.ordenarCarreras(carreras);
        } else {
          this.setCarreras([]);
          this.listadoCarreras = [];
        }
      } else {
        this.setCarreras([]);
        this.listadoCarreras = [];
        this.setAreasCarrerasInstituciones([]);
        this.clearSeleccionados;
      }
      this.$emit("cargado");
    },
    async buscarFiltrosAvanzadosPorRegion(region) {
      if (region) {
        let areasCarrerasInstituciones = await ApiBuscador.getAreaCarreraInstitucionPorRegion(
          region
        );
        if (areasCarrerasInstituciones) {
          this.setAreasCarrerasInstituciones(areasCarrerasInstituciones);
        }
      } else {
        this.setAreasCarrerasInstituciones([]);
      }
    },
    ordenarCarreras(lstadoCarreras) {
      let carreras = [];
      lstadoCarreras.forEach(i => {
        const instituto = {
          id: i.id,
          codigo: i.codigo,
          tipoInstitucion: i.tipoInstitucion,
          nombre: i.nombre,
          nombreCorto: i.nombreCorto,
          gratuidad: i.gratuidad,
          acreditacion: i.acreditacion,
          urlLogo: i.urlLogo
        };
        i.sedes.forEach(s => {
          const sede = {
            codigo: s.codigo,
            nombre: s.nombre,
            contacto: s.contacto
          };

          carreras.push(
            ...s.carreras.map(function(carr) {
              let carreraSimple = {};
              carreraSimple = {
                datos: carr,
                sede: sede,
                institucion: instituto
              };
              return carreraSimple;
            })
          );
        });
      });
      this.setCarreras(carreras);
      this.listadoCarreras = carreras;
    },
    filtrarCarreras() {
      let carreras = this.getCarreras;
      if (this.getAreaConocimientoSeleccionada !== null) {
        carreras = carreras.filter(
          c => c.datos.areaConocimiento === this.getAreaConocimientoSeleccionada
        );
        this.guardarBusquedaTags(this.getAreaConocimientoSeleccionada, "AREA");
      }
      if (this.getCarreraGenericaSeleccionada !== null) {
        carreras = carreras.filter(
          c => c.datos.nombreGenerico === this.getCarreraGenericaSeleccionada
        );
        this.guardarBusquedaTags(
          this.getCarreraGenericaSeleccionada,
          "C_GENERICA"
        );
      }
      if (this.getInstitucionSeleccionada !== null) {
        carreras = carreras.filter(
          c => c.institucion.nombre === this.getInstitucionSeleccionada
        );
        this.guardarBusquedaTags(
          this.getInstitucionSeleccionada,
          "INSTITUCION"
        );
      }
      this.listadoCarreras = carreras;
      this.$emit("cargado");
    },
    guardarBusquedaTags(busqueda, tipo) {
      let filtroNuevo = {
        tipo: tipo,
        filtro: busqueda,
        nivel: 0,
        eliminable: true
      };
      filtroNuevo = this.asignarNivel(filtroNuevo);
      let filtrosPrevios = [...this.getBusquedasAplicadas];
      let filtroRepetido = filtrosPrevios.findIndex(
        f => f.tipo === filtroNuevo.tipo
      );
      if (filtroRepetido !== -1) {
        filtrosPrevios.splice(filtroRepetido, 1);
      }
      if (filtroNuevo.filtro !== null) {
        filtrosPrevios.push(filtroNuevo);
        filtrosPrevios = this.modificarPropiedadEliminable(filtrosPrevios);
      }
      this.setBusqueda(filtrosPrevios);
    },
    borrarFiltro(filtro) {
      this.$emit("cargar");
      let filtrosAplicados = [...this.getBusquedasAplicadas];
      let indiceFiltro = filtrosAplicados.findIndex(
        f => f.tipo === filtro.tipo
      );
      if (indiceFiltro !== -1) {
        filtrosAplicados.splice(indiceFiltro);
      }
      filtrosAplicados = this.modificarPropiedadEliminable(filtrosAplicados);
      this.setBusqueda(filtrosAplicados);

      let busquedaNueva = {};
      if (filtro.tipo === "REGION" || filtro.tipo === "CARRERA") {
        filtro.tipo === "REGION" ? this.setRegionSeleccionada(null) : null;
        filtro.tipo === "CARRERA"
          ? this.setNombreCarreraSeleccionada("")
          : null;
        busquedaNueva = {
          region: this.getRegionSeleccionada,
          carrera: this.getNombreCarreraSeleccionada
        };
        this.buscarCarreras(busquedaNueva);
      } else {
        filtro.tipo === "AREA"
          ? this.setAreaConocimientoSeleccionada(null)
          : null;
        filtro.tipo === "C_GENERICA"
          ? this.setCarreraGenericaSeleccionada(null)
          : null;
        filtro.tipo === "INSTITUCION"
          ? this.setInstitucionSeleccionada(null)
          : null;
        this.filtrarCarreras();
      }
      this.$emit("cargado");
    },
    reiniciarFiltros() {
      this.setBusqueda([]);
      this.clearSeleccionados;
      this.setRegionSeleccionada(null);
      this.setNombreCarreraSeleccionada("");
      let busquedaNueva = {
        region: this.getRegionSeleccionada,
        carrera: this.getNombreCarreraSeleccionada
      };
      this.buscarCarreras(busquedaNueva);
    },
    cambiarOrden(orden) {
      this.setCriterioOrden(orden);
      let listado = this.listadoCarreras;
      switch (orden) {
        case "NOMBRE_CARRERA_ASCENDENTE":
        case "NOMBRE_CARRERA_DESCENDENTE":
          listado.sort((a, b) => {
            let n1 = a.datos.nombre;
            let n2 = b.datos.nombre;
            if (orden === "NOMBRE_CARRERA_ASCENDENTE") {
              return n1.localeCompare(n2);
            } else {
              return n2.localeCompare(n1);
            }
          });
          break;
        case "NOMBRE_INSTITUTO_ASCENDENTE":
        case "NOMBRE_INSTITUTO_DESCENDENTE":
          listado.sort((a, b) => {
            let n1 = a.institucion.nombre;
            let n2 = b.institucion.nombre;
            if (orden === "NOMBRE_INSTITUTO_ASCENDENTE") {
              return n1.localeCompare(n2);
            } else {
              return n2.localeCompare(n1);
            }
          });
          break;
        case "ARANCEL_ASCENDENTE":
        case "ARANCEL_DESCENDENTE":
          listado.sort((a, b) => {
            let n1 = a.datos.arancelAnual;
            let n2 = b.datos.arancelAnual;
            if (orden === "ARANCEL_ASCENDENTE") {
              return n1 - n2;
            } else {
              return n2 - n1;
            }
          });
          break;
        default:
          break;
      }
      this.listadoCarreras = listado;
    },
    asignarNivel(filtro) {
      switch (filtro.tipo) {
        case "AREA":
          filtro.nivel = 1;
          break;
        case "C_GENERICA":
          filtro.nivel = 2;
          break;
        case "INSTITUCION":
          filtro.nivel = 3;
          break;
        default:
          filtro.nivel = 1;
          break;
      }
      return filtro;
    },
    modificarPropiedadEliminable(listadoFiltro) {
      let indiceNivMay = 0;
      let nivel = 0;
      for (let i = 0; i < listadoFiltro.length; i++) {
        const f = listadoFiltro[i];
        if (
          f.tipo === "AREA" ||
          f.tipo === "C_GENERICA" ||
          f.tipo === "INSTITUCION"
        ) {
          if (indiceNivMay === 0) {
            indiceNivMay = i;
            nivel = f.nivel;
          }
          if (nivel <= f.nivel) {
            listadoFiltro[indiceNivMay].eliminable = false;
            listadoFiltro[i].eliminable = true;
            nivel = f.nivel;
            indiceNivMay = i;
          }
        }
      }
      return listadoFiltro;
    }
  }
};
</script>
<style scoped>
.mensaje-error {
  margin-top: -3px;
  padding: 0.5rem 1rem;
  background-color: #f7edeb;
  color: #dc3545 !important;
  border: 1px solid #dc3545 !important;
  border-bottom-right-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}
</style>



// WEBPACK FOOTER //
// src/pages/Inicio.vue